"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsFunFactsVisible = exports.getFunFacts = exports.getAvatarUrl = exports.getRole = exports.getPhone = exports.getLastName = exports.getFirstName = exports.getIsLoaded = exports.getErrors = exports.getIsLoading = void 0;

var _ramda = require("ramda");

var pathToGeneralSettings = (0, _ramda.prop)('personalGeneralSettings');
var getIsLoading = (0, _ramda.compose)((0, _ramda.prop)('isLoading'), pathToGeneralSettings);
exports.getIsLoading = getIsLoading;
var getErrors = (0, _ramda.compose)((0, _ramda.prop)('errors'), pathToGeneralSettings);
exports.getErrors = getErrors;
var getIsLoaded = (0, _ramda.compose)((0, _ramda.prop)('isLoaded'), pathToGeneralSettings);
exports.getIsLoaded = getIsLoaded;
var getFirstName = (0, _ramda.compose)((0, _ramda.prop)('firstName'), pathToGeneralSettings);
exports.getFirstName = getFirstName;
var getLastName = (0, _ramda.compose)((0, _ramda.prop)('lastName'), pathToGeneralSettings);
exports.getLastName = getLastName;
var getPhone = (0, _ramda.compose)((0, _ramda.prop)('phone'), pathToGeneralSettings);
exports.getPhone = getPhone;
var getRole = (0, _ramda.compose)((0, _ramda.prop)('role'), pathToGeneralSettings);
exports.getRole = getRole;
var getAvatarUrl = (0, _ramda.compose)((0, _ramda.prop)('avatarUrl'), pathToGeneralSettings);
exports.getAvatarUrl = getAvatarUrl;
var getFunFacts = (0, _ramda.compose)((0, _ramda.prop)('funFacts'), pathToGeneralSettings);
exports.getFunFacts = getFunFacts;
var getIsFunFactsVisible = (0, _ramda.compose)((0, _ramda.prop)('showFunFacts'), pathToGeneralSettings);
exports.getIsFunFactsVisible = getIsFunFactsVisible;